import React, { useMemo } from 'react'

import styles from './table.module.scss'
import classNames from 'classnames'
import NextIcon from '@material-ui/icons/NavigateNext'
import BackIcon from '@material-ui/icons/NavigateBefore'

const CustomPagination = ({ count, page, onChangePage, rowsPerPage }) => {
  const numPages = Math.ceil(count / rowsPerPage)
  const maxPageVisible = 3

  if (!count || isNaN(count)) return null

  const getPageNumbers = () => {
    const pages = []

    // Always include the first page
    pages.push(0)

    // Determine if left ellipsis is needed
    if (page > 2) {
      pages.push('left-ellipsis')
    }

    // Pages around the current page
    const start = Math.max(1, page - 1)
    const end = Math.min(numPages - 2, page + 1)
    for (let i = start; i <= end; i++) {
      pages.push(i)
    }

    // Determine if right ellipsis is needed
    if (page < numPages - 3) {
      pages.push('right-ellipsis')
    }

    // Always include the last page if it's not the first page
    if (numPages > 1) {
      pages.push(numPages - 1)
    }

    return pages
  }

  const renderPagination = () => {
    const pages = getPageNumbers()

    return (
      <div className={styles.pagination}>
        {pages.map((p, index) => {
          if (p === 'left-ellipsis' || p === 'right-ellipsis') {
            return (
              <span key={`ellipsis-${index}`} className={styles.ellipsis}>
                ...
              </span>
            )
          } else {
            return (
              <div
                key={p}
                className={classNames(
                  styles.paginationItem,
                  p === page && styles.paginationItemActive
                )}
                onClick={() => onChangePage(p)}
              >
                {p + 1}
              </div>
            )
          }
        })}
      </div>
    )
  }

  return (
    <div className={styles.paginationContainer}>
      <BackIcon
        onClick={() => onChangePage(Math.max(0, page - 1))}
        className={classNames(
          styles.paginationButton,
          page === 0 && styles.disabled
        )}
      />
      {renderPagination()}
      <NextIcon
        onClick={() => onChangePage(Math.min(numPages - 1, page + 1))}
        className={classNames(
          styles.paginationButton,
          page === numPages - 1 && styles.disabled
        )}
      />
    </div>
  )
}

export default CustomPagination
